<template>
  <div class="main-body">
    <div class="header">手工订单</div>
    <div class="out">

      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float: right">


          <el-select v-model="businessCode" placeholder="请选择商家" style="margin-right:5px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.businessName"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-input size="mini" v-model="elderlyName" placeholder="选择老人" disabled style="width: 200px;margin-right: 5px;">
            <el-button size="mini" slot="append" icon="el-icon-search" @click="showElderly"></el-button>
            <el-button size="mini" slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-date-picker style="margin-right: 5px;width:210px;" size="mini"
                          v-model="startEndTime"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button type="primary" plain size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table" border >

        <el-table-column prop="serialNumber" label="流水号" width="130" fixed></el-table-column>

<!--        <el-table-column prop="user.name" label="老人姓名" width="85"></el-table-column>-->
<!--        <el-table-column prop="user.phone" label="老人手机号" width="150"></el-table-column>-->

        <el-table-column prop="businessName" label="商家" width="105"></el-table-column>
        <el-table-column prop="userName" label="老人姓名" width="85"></el-table-column>


        <el-table-column prop="" label="服务项目" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" label="单价" width="105">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsPrice}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="105" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="price" label="总价" width="105"></el-table-column>

        <el-table-column width="105" label="订单类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderType ==2 ">单独服务</div>
            <div v-if="scope.row.orderType ==3 ">合并服务</div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status =='10' ">待付款</div>
            <div v-if="scope.row.status =='11' ">待接单</div>
            <div v-if="scope.row.status =='12' ">待开始</div>
            <div v-if="scope.row.status =='13' ">待结束</div>
            <div v-if="scope.row.status =='14' ">待评价</div>
            <div v-if="scope.row.status =='15' ">已取消</div>
            <div v-if="scope.row.status =='16' ">已评价</div>
            <div v-if="scope.row.status =='17' ">已关闭</div>
          </template>
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="150" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="scope.row.status==12" @click="editOrder(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" v-if="scope.row.isDelete!=1" @click="deleteOrder(scope.row)">删除</el-button>
            <el-button type="text" size="mini" @click="showInfo(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination
              background small
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <WriteAdd ref="myWriteAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></WriteAdd>
    <WriteEdit ref="myWriteEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></WriteEdit>


    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false"></Info>


    <WriteElderly ref="myElderly" v-show="showModalElderly" v-on:closeElderly="closeElderly"
                  v-on:setElderly="setElderly"></WriteElderly>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import WriteAdd from "./WriteAdd";
import WriteEdit from "./WriteEdit";
import Info from "./Info";

import WriteElderly from "@/views/Elderly/Comm/ElderlyGov"

export default {
  name: "Role",
  data() {
    return {

      loading: false,

      showModalAdd:false,
      showModalEdit:false,
      showModalInfo:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,

      startEndTime:[],
      userCode:'',
      elderlyName:'',
      showModalElderly:false,

      arr_business:[],
      businessCode:'',


    }
  },
  components: {
    WriteAdd,WriteEdit,WriteElderly,Info
  },
  created() {
    this.init();
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {
    init() {

      const now = new Date();
      const start = new Date(now - 1000 * 60 * 60 * 24 * 30);

      const end = new Date(now);
      end.setDate(now.getDate()+30)
      this.startEndTime = [timefilters(start).substring(0,10), timefilters(end).substring(0,10)];


      this.getBusiness();
    },

    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },

    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {

              let arr = response.data.data;
              for(let i=0;i<arr.length;i++){
                if(arr[i].businessType != 2){
                  this.arr_business.push(arr[i]);
                }
              }

              //this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getList();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },



    showElderly(){
      this.showModalElderly = !this.showModalElderly;
      this.$refs.myElderly.init();
    },
    closeElderly:function(){
      this.showModalElderly = !this.showModalElderly;
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.elderlyName = row.name;
      this.getCart();
    },
    clearElderly:function (){
      this.userCode = '';
      this.elderlyName = '';
    },


    showInfo(row){
      this.showModalInfo = !this.showModalInfo;
      this.$refs.myInfo.init(row.orderBusinessCode);
    },


    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myWriteAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    editOrder(row){
      this.showModalEdit = !this.showModalEdit;
      this.$refs.myWriteEdit.init(row);
    },
    closeEdit(){
      this.showModalEdit = !this.showModalEdit;
    },



    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {
      if(isSearch)this.currentPage=1
      var _this=this

      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        businessCode:this.businessCode,
        userCode:this.userCode,
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessGov/PageForGovWriteMul",
        data: data
      }).then((response) => {
        this.loading = false;
        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })
        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },




    deleteOrder(row){
      this.$confirm('是否删除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusiness/DeleteOrderBusiness",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            orderBusinessCode:row.orderBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '删除成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {

      });
    },



  }
}
</script>

<style lang="scss" scoped>


</style>
